module.exports = __webpack_public_path__ + "static/img/eye_max.ccd5df50.png";